var irreducible = require('./irreducible');

var isObject = require('./isObject');

module.exports = irreducible('Object', isObject);